import React from 'react';
import Icon from '@material-ui/icons/Comment';

export const CommentaryIcon = Icon;